document.addEventListener("turbolinks:load", function() {
    if($("body").data("controller") == "activities") {
        let tableActivities;
        let cancelUploading = false;
        
        document.addEventListener("turbolinks:before-cache", function() {
            if (tableActivities != null) {
                tableActivities.destroy();
            }
        })

        tableActivities = $('#table-activities').DataTable({
            'initComplete': function(settings){
                var api = this.api();
       
                api.cells(
                   api.rows(function(idx, data, node){
                      return ($(node).data('related')) ? true : false;
                   }).indexes(),
                   0
                ).checkboxes.disable();
            },
            'columnDefs': [
                {
                   'targets': 0,
                   'checkboxes': {
                        'selectRow': false,
                        'selectCallback': function(nodes, selected) {
                            refresh_selected_elements()
                        }
                    }
                }
            ],
            'select': {
                'style': 'multi',
                "selector": 'td:first-child'
            },
            "bPaginate": true,
            "bFilter": true,
            "bInfo": false,
            "bLengthChange": false,
            "searching": true,
            "destroy": true,
            "scrollCollapse": true,
            "stateSave": false,
            "oLanguage": {
                "sLengthMenu": "_MENU_ ",
                "sInfo": "Showing <b>_START_ to _END_</b> of _TOTAL_ entries"
            },
            "bAutoWidth": false,
            'order' : [[0,'desc']]
        });
        $("#table-activities_wrapper > div > .col-sm-6:nth-child(1)").addClass("content-left")
        $("#table-activities_wrapper > .row > div:first").append("<div><span>" +
            "<div class='form-check checkbox-circle complete filter-passed'>" + 
                "<input type='checkbox' id='filter-show_not_active' checked>" + 
                "<label for='filter-show_not_active'>Show inactive</label>" +
            "</div>" + 
        "</span></div>")

        // toggle active/inactive activities
        $("#filter-show_not_active").on("change", function() {
            if($(this).prop("checked")) {
                $.fn.dataTable.ext.search.pop();
            }
            else {
                $.fn.dataTable.ext.search.push(
                    function(settings, data, dataIndex) {
                       return $(tableActivities.row(dataIndex).node()).attr('data-active') == 'true';
                    }
                 );
            }

            tableActivities.draw();
        })

        $("#activity-input").on("click", function() {
            document.getElementById("upfile").click();
        })
        
        $("#upfile").on("change", function(obj) {
            var file_origine = this
            var file = this.value;
            if (file != "") {
                if (isVideo(this.value)) {
                    var fileName = file.split("\\");
                    document.getElementById("activity-input").innerHTML = fileName[fileName.length - 1];
                    $(this).attr("disabled", true)

                    $.ajax({
                        url: "/activities/prepare_activity",
                        type: 'PUT',
                        dataType: "json",
                        success: function (data) {
                            console.log(data)
                            $("#activity-id").val(data.activity_id)
                            upload(file_origine, data.activity_id)
                        },
                        error: function(data) {
                        }
                    });
                }
                else {
                    $(".activity-upload-error").removeClass("hidden")
                }
            }
        })

        function upload(file, activity_id) {
            $(".activity-progress").removeClass("hidden")
            $(".activity-progress .progress").append("<div class='activity-progress-upload-length w-100 pt-2 text-center' style='position: absolute; font-weight: bold;'>0%</div>" +
                "<div class='progress-bar progress-bar-striped progress-bar-animated activity-progress-upload' role='progressbar' aria-valuenow='75' aria-valuemin='0' aria-valuemax='100' style='margin-right: auto; width: 0%'>" +
            "</div>")

            var uploader = new VideoUploader({
                videoId: activity_id,
                file: file.files[0],
                uploadToken: "to5pYv2Li3irOb9HwHTdhkE6",
                retries: 10000000
            })

            uploader.upload().then((video) => {
                $(".activity-success-info").removeClass("hidden")
                $(".activity-success-id").text(video.videoId)
                $(".activity-success-url").text(video.assets.mp4)
                $(".activity-success-url").parent().attr("href", video.assets.mp4) 
               
                //$("#video-player").html(video.assets.iframe) 

                $("#activity-url").val(video.assets.mp4)
                $("#activity-id").val(video.videoId)

                $(".activity-progress").addClass("hidden")
                $(".activity-upload-success").removeClass("hidden")
                $("#btn-save-activity").attr("disabled", false)
                $("#upfile").attr("disabled", false)
            })
            .catch((error) => console.log(error.status, error.message));

            uploader.onProgress((event) => {

                if (cancelUploading) {
                    $(".activity-progress .progress div").remove()
                    resetUpload()
                    cancelUploading = false
                }

                percent = (event.uploadedBytes / event.totalBytes) * 100
                percent = Number.parseFloat(percent).toFixed(2)

                if (percent > 100) {
                    percent = 100
                }

                $(".activity-progress-upload").css("width", percent  + "%")
                $(".activity-progress-upload-length").text(percent  + "%")
            })
            
        }

        // cancel uploading
        $("#activity-cancel_uploading").on("click", function() { 
            Swal.fire({
                title: 'Are you sure?',
                text: "The video will be deleted from the server!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        url: "/videos/cancel_uploading/" + $("#video-id").val(),
                        type: 'DELETE',
                        dataType: "json",
                        success: function (data) {
                            cancelUploading = true
                        },
                        error: function(data) {
                        }
                    });
                }
            })
        })

        function resetUpload() {
            $("#activity-id").val("")
            $(".activity-progress").addClass("hidden")
            $(".activity-success-info").addClass("hidden")
            $(".activity-progress-upload").css("width", "0%")
            $(".activity-progress-upload-length").text("0%")
            $(".activity-upload-error").addClass("hidden")
            $("#upfile").attr("disabled", false)
            $("#activity-input").text("CLICK TO CHOOSE A FILE")
        }

        function isVideo(filename) {
            var parts = filename.split('.');
            ext = parts[parts.length - 1];

            switch (ext.toLowerCase()) {
              case 'm4v':
              case 'avi':
              case 'mpg':
              case 'mp4':
                // etc
                return true;
            }
            return false;
        }

        const lightbox = GLightbox();

        FilePond.registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateSize, FilePondPluginFileValidateType);
     
        const pond_image = FilePond.create(document.querySelector('#activity-image'), {
            acceptedFileTypes: ['image/png', 'image/jpg', 'image/jpeg'],
            labelIdle: "Drag & Drop your image or <span class='filepond--label-action'> Browse </span>",
            imagePreviewMinHeight: 128,
            imagePreviewMaxHeight: 128,
            imagePreviewHeight: 128,
            allowProcess: false,
            instantUpload: false,
            name: 'activity[image]',
            storeAsFile: true,
            credits: {label: "", url: ""} ,
            maxFileSize: 300000,
        });

        const pond_file = FilePond.create(document.querySelector('#activity-file'), {
            acceptedFileTypes: ['application/pdf'],
            labelIdle: "Drag & Drop your file or <span class='filepond--label-action'> Browse </span>",
            allowProcess: false,
            instantUpload: false,
            name: 'activity[file]',
            storeAsFile: true,
            credits: {label: "", url: ""} ,
            maxFileSize: 2000000,
        });

        $("#btn-save-activity").on("click", function() {
            $("#form-activity").validate()

            if ($("#form-activity").valid()) {
                $(".loader").removeClass("hidden")
                $(".btn-cancel").attr("disabled", true)
                $("button[type='submit']").attr("disabled", true)

                document.getElementById("form-activity").submit()
            }
        })

        // delete activity
        $(".delete-activity").on("click", function() {
            activity_id = $(this).parent().parent().attr("data-activity_id")

            Swal.fire({
                title: 'Are you sure?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    destroy(activity_id, null)
                }
            })
        })

        // change state
        $(".change-state").on("click", function() {
            let text = $(this).text() == "true" ? 'Inactive' : 'Active'
            let state = $(this).text() == "true" ? false : true

            Swal.fire({
                title: `Change this activity's state to ${text} ?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, change it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    activity_id = $(this).parent().parent().attr("data-activity_id")
                    changeState(activity_id, state)
                }
            })
        })

        // change state selected elements
        $("#state-selected-elements").on("click", function() {
            Swal.fire({
                title: "Change all selected elements state to ?",
                input: 'select',
                inputOptions: {
                  'true': 'Active',
                  'false': 'Inactive'
                },
                inputPlaceholder: 'Select a state',
                showCancelButton: true,
                inputValidator: (value) => {
                  return new Promise((resolve) => {
                        if (value == "")
                            resolve("Please choose a state")
                        else {
                            changeState(null, value, rows_selected.join(","))
                        }
                  })
                }
            })
        });

        //select elements
        $("#table-activities input[type=checkbox]").on("change", function() {
            refresh_selected_elements()
        })
        
        // delete selected elements
        $("#delete-selected-elements").on("click", function() {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    elements = rows_selected
                    $.each(elements, function(index, rowId){
                        $(`#table-activities tr[data-activity_id='${rowId}'] td:nth-child(7)`).html("<b>Deleting...</b>");
                        $(`#table-activities tr[data-activity_id='${rowId}'] td:nth-child(6) a`).removeAttr("href")
                        $(`#table-activities tr[data-activity_id='${rowId}'] .change-state`).off( "click", "");
                        tableActivities.cells(`tr[data-activity_id='${rowId}']`, 0).checkboxes.disable()
                    })

                    destroy(null, rows_selected.join(","))
                }
            })
        })

        function changeState(activity_id, state, elements) {
            if (activity_id != null) {
                $.ajax({
                    url: "/activities/change_state/" + activity_id,
                    type: 'PUT',
                    dataType: "json",
                    data: {
                        state: state
                    },
                    success: function (data) {
                        $(`#table-activities tr[data-activity_id='${activity_id}'] .change-state`).text(state);
                        $(`#table-activities tr[data-activity_id='${activity_id}']`).toggleClass("tr-deactivated")
                        $(`#table-activities tr[data-activity_id='${activity_id}']`).attr("data-active", state)
                        if (state) {
                            $(`#table-activities tr[data-activity_id='${activity_id}'] .change-state`).addClass("badge-success")
                            $(`#table-activities tr[data-activity_id='${activity_id}'] .change-state`).removeClass("badge-warning")
                        }
                        else {
                            $(`#table-activities tr[data-activity_id='${activity_id}'] .change-state`).addClass("badge-warning")
                            $(`#table-activities tr[data-activity_id='${activity_id}'] .change-state`).removeClass("badge-success")
                        }
                    },
                    error: function(data) {
                    }
                });
            }
            else if (elements != null) {
                $(".total-selected-content").addClass("hidden")

                $.ajax({
                    url: "/activities/change_state",
                    type: 'PUT',
                    dataType: "json",
                    data: {
                        elements_id: elements,
                        state: state
                    },
                    success: function (data) {
                        elements = elements.split(',')
                        
                        $.each(elements, function(index, rowId){
                            $(`#table-activities tr[data-activity_id='${rowId}'] .change-state`).text(state);
                            $(`#table-stories tr[data-activity_id='${rowId}']`).attr("data-active", state)
                            tableActivities.cells(`tr[data-activity_id='${rowId}']`, 0).checkboxes.deselect()

                            
                            if (state == "true") {
                                $(`#table-activities tr[data-activity_id='${rowId}'] .change-state`).addClass("badge-success")
                                $(`#table-activities tr[data-activity_id='${rowId}'] .change-state`).removeClass("badge-warning")

                                $(`#table-activities tr[data-activity_id='${rowId}']`).removeClass("tr-deactivated")
                            }
                            else {
                                $(`#table-activities tr[data-activity_id='${rowId}'] .change-state`).addClass("badge-warning")
                                $(`#table-activities tr[data-activity_id='${rowId}'] .change-state`).removeClass("badge-success")
                                
                                $(`#table-activities tr[data-activity_id='${rowId}']`).addClass("tr-deactivated")
                            }
                            
                        });

                        refresh_selected_elements()

                        Swal.close()
                    },
                    error: function(data) {
                    }
                });
            }
        }

        function destroy(activity_id, elements) {
            if (activity_id != null) {
                $(`#table-activities tr[data-activity_id='${activity_id}'] td:nth-child(7)`).html("<b>Deleting...</b>");
                $(`#table-activities tr[data-activity_id='${activity_id}'] td:nth-child(6) a`).removeAttr("href")
                $(`#table-activities tr[data-activity_id='${activity_id}']`).addClass("tr-deleting")
                $(`#table-activities tr[data-activity_id='${activity_id}'] .change-state`).off( "click", "");
                
                tableActivities.cells(`tr[data-activity_id='${activity_id}']`, 0).checkboxes.disable()
                refresh_selected_elements()

                $.ajax({
                    url: "/activities/" + activity_id,
                    type: 'DELETE',
                    dataType: "json",
                    success: function (data) {
                        tableActivities.row($(`tr[data-activity_id='${activity_id}']`)).remove().draw();

                        if (data.name != null) {
                            messageDeleted = `The activity "${data.title}" has been deleted.`
                        }

                    },
                    error: function(data) {
                    }
                });
            }
            else {
                $(".total-selected-content").addClass("hidden")

                $.ajax({
                    url: "/activities/delete_elements",
                    type: 'DELETE',
                    dataType: "json",
                    data: {
                        elements_id: elements
                    },
                    success: function (data) {
                        elements = elements.split(',')

                        $.each(elements, function(index, rowId){
                            tableActivities.row($(`tr[data-activity_id='${rowId}']`)).remove().draw();
                        });

                        $(".total-selected-content").addClass("hidden")
                    },
                    error: function(data) {
                    }
                });
            }
        }


        function refresh_selected_elements() {
            rows_selected = tableActivities.column(0).checkboxes.selected();

            if (rows_selected.length == 0) {
                $(".total-selected-content").addClass("hidden")
                $(".total-selected-content").css("marginBottom", 0)
                $(".total-selected-content").css("opacity", 0)
            }
            else {
                $(".total-selected-content").removeClass("hidden")
                $(".total-selected-content").animate({
                    marginBottom: 10,
                    opacity: 1
                }, 100, "linear",  function() {
                });
            }
            
            $.each(rows_selected, function(index, rowId){
            });

            let txt = rows_selected.length > 1 ? `${rows_selected.length} elements selected` : `${rows_selected.length} element selected`
            $(".total-selected").text(txt)

            return rows_selected
        }

    }
})